import { render, staticRenderFns } from "./BottomCards.vue?vue&type=template&id=24056a06&scoped=true&"
import script from "./BottomCards.vue?vue&type=script&lang=js&"
export * from "./BottomCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24056a06",
  null
  
)

export default component.exports